module.exports = __webpack_public_path__ + "img/courrier-expedition.6130f080.svg";